import { render } from "./embedded-selector.vue?vue&type=template&id=5ac208bb&scoped=true"
import script from "./embedded-selector.vue?vue&type=script&lang=js"
export * from "./embedded-selector.vue?vue&type=script&lang=js"

import "./embedded-selector.vue?vue&type=style&index=0&id=5ac208bb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac208bb"]])

export default __exports__